import Home from './Home';
import MyBJList from './prime/MyBJList';
import EditNickname from './profile/EditNickname';
import Language from './languageSetting/Language';

const PAGES = [
  { path: '/', element: Home },
  { path: Def.PAGE_PRIME_MYBJ, element: MyBJList },
  { path: Def.PAGE_EDITNICK, element: EditNickname },
  { path: Def.PAGE_LANGUAGE, element: Language },
];

export default PAGES;
